/**
 * „Neue Antwort" pro Browser: wann hat dieser Salon das Ticket zuletzt
 * geöffnet? Reine Komfortfunktion — fehlt der Speicher (privates Fenster,
 * blockiert), zeigt die Liste eben jede Team-Antwort als neu.
 */
const KEY = (id: number) => `supportTicketSeen:${id}`;

export function markTicketSeen(id: number, lastMessageAt: string | null): void {
  if (!lastMessageAt) return;
  try {
    localStorage.setItem(KEY(id), lastMessageAt);
  } catch {
    // Speicher nicht verfügbar — egal.
  }
}

export function hasUnseenTeamReply(
  id: number,
  lastMessageAuthor: 'customer' | 'team' | null,
  lastMessageAt: string | null,
): boolean {
  if (lastMessageAuthor !== 'team' || !lastMessageAt) return false;
  try {
    const seen = localStorage.getItem(KEY(id));
    return !seen || new Date(lastMessageAt).getTime() > new Date(seen).getTime();
  } catch {
    return true;
  }
}
